import { FC, SVGProps, useCallback, useState } from 'react';
import { IconButton, IconButtonStyles, Icons, Tooltip } from '@silverfort/sf-components';
import CopyToClipboard from 'react-copy-to-clipboard';

interface CopyIconProps {
    value: string;
    className?: string;
    tooltipText?: string;
    copiedTooltipText?: string;
}

const CopyIcon: FC<CopyIconProps> = ({
    value,
    className,
    tooltipText = 'Copy',
    copiedTooltipText = 'Copied to clipboard'
}) => {
    const [showCopied, setShowCopied] = useState(false);

    const onCopy = useCallback(() => {
        setShowCopied(true);
        setTimeout(() => setShowCopied(false), 2000);
    }, []);

    const icon = (showCopied ? Icons.Check : Icons.Copy) as FC<SVGProps<SVGSVGElement>>;

    return (
        <Tooltip title={showCopied ? copiedTooltipText : tooltipText} className="w-fit">
            <CopyToClipboard text={value} onCopy={onCopy} className={`flex items-center ${className}`}>
                <IconButton buttonStyle={IconButtonStyles.Secondary} icon={icon} iconClassName="text-sf-gray-400" />
            </CopyToClipboard>
        </Tooltip>
    );
};

export default CopyIcon;
